import { range } from "lodash"
import { CCUtils } from "../../../../common/CCUtils"
import { CameraZoom, ZoomInfo, ZoomTarget } from "../../../utils/CameraZoom"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { EveryCigAtlases } from "../EveryCigAssets"
import { EveryCigSprite } from "../EveryCigTypes"

export class EveryCigDropdownScreenContainer implements EveryCigSprite {

    static target: ZoomTarget
    private static OPEN = "OPEN"
    screen: Phaser.Sprite
    open: Phaser.Animation
    private close: () => void
    private undoZoom: ZoomInfo

    constructor(
        private game: Phaser.Game,
        group: Phaser.Group,
        x: number,
        y: number
    ) {
        this.screen = Sprites.add(game, EveryCigAtlases.DROPDOWN_SCREEN, {debug: CCUtils.debug, group, x, y})
        this.open = this.screen.animations.add(EveryCigDropdownScreenContainer.OPEN, range(10), 20)
        EveryCigDropdownScreenContainer.target = new ZoomTarget(Scale.x(0.55), Scale.y(0), Scale.x(0.4), Scale.y(0.525))
    }

    openScreen = (onComplete: () => void) => {
        this.open.play()
        this.open.onComplete.addOnce(onComplete)
    }

    addClose = (close: () => void) => this.close = close

    // Due to some of the weirdness of reversing animations and event functions, you need to re-add the display function every time.
    zoomIn = (onComplete: () => void) => {
        this.openScreen(onComplete)
        this.undoZoom = CameraZoom.zoom(this.game, EveryCigDropdownScreenContainer.target)
    }

    zoomOut = (onStart: () => void) => {
        const close = this.open.reverse()
        close.onStart.add(onStart)
        if (this.close) {
            close.onComplete.add(this.close)
        }
        close.play()
        CameraZoom.performZoom(this.undoZoom)
    }

    destroy = () => this.screen.destroy()
}
